var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3321 6.54515C5.88894 5.58811 7.1222 5.26021 8.08666 5.81275L18.9914 12.0601C19.9559 12.6127 20.2863 13.8364 19.7295 14.7934L19.6679 14.8993C19.1111 15.8564 17.8778 16.1843 16.9133 15.6317L6.00858 9.38437C5.04411 8.83183 4.71366 7.60807 5.27049 6.65104L5.3321 6.54515Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79853 10.6921C7.29053 8.12775 10.595 7.24915 13.1792 8.72966L13.8991 9.14208C16.4833 10.6226 17.3687 13.9016 15.8767 16.4659C14.3847 19.0302 11.0803 19.9088 8.49604 18.4283L7.77617 18.0159C5.19194 16.5354 4.30652 13.2564 5.79853 10.6921Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6574 2.1342C14.1396 2.41048 14.3049 3.02235 14.0264 3.50087L10.7015 9.21546C10.4231 9.69398 9.80646 9.85793 9.32422 9.58166C8.84199 9.30538 8.67677 8.69351 8.95518 8.21499L12.2801 2.5004C12.5585 2.02188 13.1752 1.85793 13.6574 2.1342Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4164 5.4334C19.8986 5.70968 20.0638 6.32155 19.7854 6.80007L16.4605 12.5147C16.1821 12.9932 15.5654 13.1571 15.0832 12.8809C14.601 12.6046 14.4358 11.9927 14.7142 11.5142L18.0391 5.7996C18.3175 5.32108 18.9342 5.15713 19.4164 5.4334Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18481 21.2936L7.91342 16.604L9.65974 17.6044L6.93113 22.2941L5.18481 21.2936Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.a3fc6d5eb025dada2241020ef418c156.svg";
export { ForwardRef as ReactComponent };